export default [
  {
    path: "/planned-expenses",
    name: "planned-expenses-list",
    meta: {
      title: "Список плановых расходов",
      authRequired: true,
    },
    component: () => import("@/modules/planned-expenses/views/items.vue"),
  },
  {
    path: "/planned-expenses/:id",
    name: "planned-expenses-edit",
    meta: {
      title: "Плановый расход",
      authRequired: true,
    },
    component: () => import("@/modules/planned-expenses/views/edit.vue"),
  },
  {
    path: "/planned-expenses/new",
    name: "planned-expenses-create",
    meta: {
      title: "Плановый расход",
      authRequired: true,
    },
    component: () => import("@/modules/planned-expenses/views/edit.vue"),
  },
];
